export default __webpack_public_path__ + "static/media/grupo-logo.dd895d2b.png";